import { SettingsMediaImage, Settings, WidgetData } from "./data"
import { WpMediaImage, loadImage } from "./wp-media-image"
import { Widget } from "./widget"

export type ImageData = WidgetData & {
  settings: Settings & {
    image?: SettingsMediaImage,
  },
  widgetType: "image"
}

export class ImageWidget extends Widget {
  image: WpMediaImage | undefined

  constructor(data: ImageData) {
    super(data);
    this.image = data.settings.image &&
      loadImage(data.settings.image);
  }
}
